/**
 * External dependencies.
 */
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Layout, Page, Section, Header, Spacer, Title, Button, Dialog, withDevice, Loader } from 'sg-styleguide';

/**
 * Internal dependencies.
 */
import InstallationDialog from '../../components/dialog';
import Stepper from '../../components/stepper';
import Intro from '../../components/steps/intro';
import Themes from '../../components/steps/themes';
import Plugins from '../../components/steps/plugins';
import WizardLogo from '../../components/logo';

import { FlexWithPadding, localize } from '../../components/helpers';
import {
	StepChangeNext,
	StepChangePrev,
	AddTheme,
	AddThemeTag,
	AddPlugin,
	checkStatus,
	sendRequest,
	sendStatistics,
	onPageInit,
	onPageResize
} from '../../actions/actions';

const WizardLayout = withDevice(Layout);

class Wizard extends React.Component{

	constructor( props ) {
		super(props);

		this.interval = '';
	}

	componentDidUpdate() {
		if (
			this.props.status === 'completed' ||
			this.props.status === 'failed'
		) {
			clearInterval( this.interval );
			if ( this.props.status === 'completed' ) {
				this.props.sendStatistics({event:'dashboard_used_person'});
			}
		}
	}

	isStoreReady() {
		if (
			( this.props.steps && this.props.steps.length ) &&
			( this.props.themes && this.props.themes.length ) &&
			( this.props.plugins && this.props.plugins.length )
		) {
			return true;
		}

		return false;
	}

	renderSteps() {
		var components = {
			intro: Intro,
			themes: Themes,
			plugins: Plugins,
		};

		if ( this.isStoreReady() ) {	
			return this.props.steps.map( (step, i) => {

				var TagName = components[step.type];

				if ( i === this.props.currentStep ) {
					return <TagName
						key={i}
						step={step}
						elements={this.props[step.type]}
						{...this.props}
					/>
				}
			}) 
		}
	}

	renderContent() {
		if ( ! this.isStoreReady() ) {
			return (
				<Loader theme="dark">
					Loading...
				</Loader>
			);
		} else {
			return this.renderSteps()
		}
	}

	sendStatistics() {
		var event = 'wizard_skipped_step_zero';

		switch( this.props.currentStep ) {
			case 1:
				event = 'wizard_skipped_step_one';
				break;
			case 2:
				event = 'wizard_skipped_step_two'
				break;
			case 3:
				event = 'wizard_skipped_step_three'
				break;
		}

		this.props.sendStatistics( { event: event } );

	}

	exitWizard = ( url, sendStatistics ) => {
		if ( true === sendStatistics ) {
			this.sendStatistics();
		}

		setTimeout(function() {
			window.location = url;
		}, 1200)
	}


	complete = () => {
		var isReseller = window.wizardData.is_reseller !== 'undefined' && window.wizardData.is_reseller === 'yes' ? 1 : 0;

		this.props.sendRequest({
			theme: this.props.selectedTheme,
			plugins: this.props.selectedPlugins,
			theme_tags: this.props.selectedThemeTags,
			ip: window.wizardData.ip,
			is_reseller: isReseller
		});

		this.interval = setInterval( this.props.checkStatus, 3000 );
	}

	onClickStepButton() {
		( this.props.currentStep === this.props.totalSteps ) ? this.complete() : this.props.changeStepNext();
	}

	render() {
		if ( ! this.isStoreReady() ) {
			return 	(
				<Loader theme="dark">
					Loading...
				</Loader>
			);
		}

		return (
			<WizardLayout
				onInit={(device) => this.props.onPageInit(device)}
				onResize={(device) => this.props.onPageResize(device)}
			>
				<Page>
					<Header>
						<Section
							density="none"
						>
							<FlexWithPadding
								padding={['none', 'medium', 'none', 'medium']}
								margin="none"
								flex-direction="row"
								align="center"
							>

								<WizardLogo />

								<Spacer />

								<Stepper
									currentStep={this.props.currentStep}
									totalSteps={this.props.totalSteps}
								/>

								{this.props.isPhone === false && <Spacer />}
								{this.props.isPhone === false && <Title
									level="4"
									color="white"
									density="none"
									weight="bold"
								>
									WordPress Starter
								</Title>}
							</FlexWithPadding>
						</Section>

					</Header>

					{ this.props.status !== 'default' &&
						<InstallationDialog
							status={this.props.status}
							percent={this.props.installationPercent}
							message={this.props.installationMessage}
							onClick={this.exitWizard}
							restart={this.complete}
						/>
					}

					{ this.renderContent() }

					<FlexWithPadding
						padding={['large', 'none', 'none', 'none']}
						justify="center"
						align="center"
					>
						<Button
							onClick={e=> this.onClickStepButton()}
							color="primary"
							size="x-large"
						>
							{localize(this.props.buttonNextText)}

						</Button>
					</FlexWithPadding>

					<FlexWithPadding
						justify="center"
						align="center"
					>
						{ this.props.currentStep > 1  &&
							<Button
								color="secondary"
								size="large"
								type="link"
								onClick={this.props.changeStepPrev}
							>
								{window.wizardData.strings.previous}
							</Button>
						}
						<Button
							color="secondary"
							size="large"
							type="link"
							onClick={e => this.exitWizard(window.wizardData.dashboard_url, true)}
						>
							{window.wizardData.strings.exit_wizard}
						</Button>
					</FlexWithPadding>
				</Page>
			</WizardLayout>
		);
	}
}

const mapStateToProps = state => {
	return {
		plugins: state.dataReducer.plugins,
		themes: state.dataReducer.themes,
		recommendedPlugins: state.dataReducer.recommendedPlugins,
		currentStep: state.stepsReducer.currentStep,
		totalSteps: state.stepsReducer.totalSteps,
		steps: state.stepsReducer.stepsInfo,
		buttonNextText: state.stepsReducer.buttonNextText,
		selectedPlugins: state.userChoiceReducer.selectedPlugins,
		selectedTheme: state.userChoiceReducer.selectedTheme,
		selectedThemeTags: state.userChoiceReducer.selectedThemeTags,
		status: state.Installation.status,
		installationPercent: state.Installation.installationPercent,
		installationMessage: state.Installation.installationMessage,
		isPhone: state.Environment.isPhone
	};
};

const mapDispatchToProps = dispatch => {
	return {
		addPlugin: (id) => dispatch(AddPlugin(id)),
		changeStepNext: () => dispatch(StepChangeNext()),
		changeStepPrev: () => dispatch(StepChangePrev()),
		checkStatus: () => dispatch(checkStatus()),
		sendRequest: (data) => dispatch(sendRequest(data)),
		onPageInit: (data) => dispatch(onPageInit(data)),
		onPageResize: (data) => dispatch(onPageResize(data)),
		sendStatistics: (data) => dispatch(sendStatistics(data)),
		addThemeTag: (data) => dispatch(AddThemeTag(data)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(
	Wizard
);
